var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"component-auction-item",on:{"click":_vm.handleNavDetail}},[_c('auction-card',{attrs:{"auto-height":"50%","auction":_vm.auction}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }